import { graphql } from "react-relay";

export const ORDERS_FRAGMENT = graphql`
	fragment ordersTable_OrdersFragment on Query
	@refetchable(queryName: "ordersTable_OrdersFragmentRefetch")
	@argumentDefinitions(
		username: { type: "String" }
		email: { type: "String" }
		accountId: { type: "ID" }
		userId: { type: "ID" }
		guestOnly: { type: "Boolean" }
		awaitingAccountOnly: { type: "Boolean" }
		filterByCreatedAtFrom: { type: "ZonedDateTIme" }
		filterByCreatedAtTo: { type: "ZonedDateTIme" }
		first: { type: "Int" }
		after: { type: "String" }
	) {
		Admin {
			Billing {
				Orders(
					first: $first
					after: $after
					username: $username
					email: $email
					accountId: $accountId
					userId: $userId
					guestOnly: $guestOnly
					awaitingAccountOnly: $awaitingAccountOnly
					filterByCreatedAtFrom: $filterByCreatedAtFrom
					filterByCreatedAtTo: $filterByCreatedAtTo
				) @connection(key: "OrdersTable_Orders") {
					pageInfo {
						startCursor
						endCursor
						hasNextPage
						hasPreviousPage
					}
					edges {
						node {
							...ordersTable_OrderFragment
						}
					}
				}
			}
		}
	}
`;

export const ORDER_FRAGMENT = graphql`
	fragment ordersTable_OrderFragment on Order @inline {
		id
		createdAt
		status
		purchaser {
			accountId
			userId
		}
		selectedPaymentMethod {
			kind
			paymentMethodType
		}
		startedAsGuest
		...orderPriceDisplay_OrderFragment
		...paymentProviderLink_OrderFragment
	}
`;
